import React, { useState, useEffect } from 'react';

const FillInTheBlankQuestion = ({ event, onCorrect, onWrong }) => {
  const [missingWord, setMissingWord] = useState('');
  const [description, setDescription] = useState('');
  const [userInput, setUserInput] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const words = event.description.split(' ').filter(w => w.length > 3);
    const importantWords = words.filter(w => w[0] === w[0].toUpperCase());
    const randomWord = importantWords.length > 0
      ? importantWords[Math.floor(Math.random() * importantWords.length)]
      : words[Math.floor(Math.random() * words.length)];

    const blanked = event.description.replace(randomWord, '____');
    setMissingWord(randomWord);
    setDescription(blanked);
  }, [event]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (userInput.trim().toLowerCase() === missingWord.trim().toLowerCase()) {
      onCorrect();
    } else {
      onWrong();
    }
  };

  return (
    <div className="text-center">
      <h3 className="text-lg font-bold text-blue-300 mb-4">{event.title}</h3>
      <p className="text-gray-300 mb-4">{description}</p>
      <form onSubmit={handleSubmit} className="flex flex-col items-center gap-4">
        <input
          type="text"
          placeholder="Type missing word..."
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          disabled={submitted}
          className="bg-gray-800 border border-gray-600 rounded px-4 py-2 text-white"
        />
        {!submitted && (
          <button
            type="submit"
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold"
          >
            🚀 Submit
          </button>
        )}
      </form>
    </div>
  );
};

export default FillInTheBlankQuestion;
